import { FC, PropsWithChildren, useDeferredValue, useEffect } from 'react'
import { useSize } from 'ahooks'
import { setElementVars } from '@vanilla-extract/dynamic'

import { Spinner } from '@trustycars/genie-ui/components'

import { screenSizes } from '$styles/app'
import { isAllTrue } from '$app/utilities'
import { siteZoom } from '$styles/global/tokens.css'

import useSignal from '$actions/useSignal'
import { status } from '$store/status'

import { loaderControl } from './style.css'

const elHTML = document.querySelector('html')
const elBody = document.body

/**
 * Views Controller
 */
export const Views: FC<PropsWithChildren> = ({ children }) => {
  const size = useSize(elHTML)
  const zoom = useDeferredValue(
    Math.max((size?.width || 0) / screenSizes.desktop, 1)
  )

  const { isApiPrepared, isQueryParamsCached, isSettingsReady } =
    useSignal(status)

  const indicators = [isApiPrepared, isQueryParamsCached, isSettingsReady]

  const isReady = isAllTrue(indicators)

  useEffect(() => {
    setElementVars(elBody, {
      [siteZoom]: zoom.toString()
    })
  }, [zoom])

  if (!isReady) {
    return (
      <article className={loaderControl}>
        <Spinner color="neutral.100" />
      </article>
    )
  }

  return children
}

export default Views
